export default {
    ca: {
        heading: {
            title: 'Impressió del mapa a escala',
        },
        buttons: {
            anar: 'Anar a imprimir a escala',
        },
    },
    es: {
        heading: {
            title: 'Impresión del mapa a escala',
        },
        buttons: {
            anar: 'Ir a imprimir escala',
        },
    },
    en: {
        heading: {
            title: 'Print map to scale',
        },
        buttons: {
            anar: 'Go to print map to scale',
        },
    },
};



// WEBPACK FOOTER //
// ./src/map-viewer/components/printscale-modal/printscale-modal-translations.js